import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Chennai.css';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import favicon from "../../../assets/images/favicon.ico";
import {
  FaMapMarkerAlt, FaPhone, FaCalendarCheck, FaLeaf,
  FaTooth, FaHospital, FaArrowRight, FaCheckCircle,
  FaGlobe, FaWhatsapp, FaClock, FaStar,
  FaUserMd, FaAward, FaHeartbeat,
  FaRegLightbulb, FaShieldAlt, FaCertificate, FaUserCheck, FaCoins, FaUserShield, FaWallet, FaCheck,
  FaLocationArrow, FaUsers,
  FaDirections
} from 'react-icons/fa';
import { GiHairStrands, GiMedicalDrip, GiMedicalPack } from 'react-icons/gi';
import { MdFace, MdHealthAndSafety, MdOutlineHealthAndSafety, MdSupportAgent } from 'react-icons/md';
import { RiMentalHealthFill } from 'react-icons/ri';
import { BiBody } from 'react-icons/bi';
import { Helmet } from 'react-helmet';
import chennaiiiskin from '../../../assets/images/tambaramskinicon.png';
import tambaramhair from '../../../assets/images/tambaramhairicon1.png';
import tambaramleaf from '../../../assets/images/tambaramleaf.jpg';
import tambarambanner3 from '../../../assets/images/tambarambanner4.png';
// Import combined Before-After images
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";
import img11 from "../../../assets/images/autoscrollskin1.png";
import img12 from "../../../assets/images/autoscrollskin2.png";
import img13 from "../../../assets/images/autoscrollskin3.png";
import img14 from "../../../assets/images/autoscrollskin4.png";
import img15 from "../../../assets/images/autoscrollskin5.png";
import img16 from "../../../assets/images/autoscrollskin6.png";
import img17 from "../../../assets/images/autoscrollskin7.png";
import img18 from "../../../assets/images/autoscrollskin8.png";
import img19 from "../../../assets/images/autoscrollskin9.png";
import img20 from "../../../assets/images/autoscrollskin10.png";

import chennaitambarm from '../../../assets/images/chennaitambarmhair.jpg';
import chennaitambarmskin from '../../../assets/images/chennaitambaramskin.jpg';
import chennaitambaramhomeopathy from '../../../assets/images/chennaitambaramhomeopathy1.jpg';
import chennaitambaramskin1 from '../../../assets/images/chennaitambaramskin1.jpg';
import chennaitambaramskin2 from '../../../assets/images/chennaitambaramskin2.jpg';
import chennaitambaramprp from '../../../assets/images/chennaitambaramprp.jpg';
import chennaitambaramgfc from '../../../assets/images/chennaitambarmgfc.png';
import chennaitambaramantiage from '../../../assets/images/chennaitambaramantiaging.jpg';
import chennaitambaramanstm from '../../../assets/images/chennaitambaramstm1.jpg';
// import chennaitambaramandental from '../../../assets/images/chennaitambarmdental.jpg';
import chennaitambaramandental1 from '../../../assets/images/chennaitambaramandental2.jpg';
import chennaitambaramdentalinvisible from '../../../assets/images/chennaitambaramdentalinvisible.jpg';
import chennaitambarampcos from '../../../assets/images/chennaitambarampcos.jpg';
import chennaitambaramchronic from '../../../assets/images/chennaitambaramchronic.png';
import chennaitambarammentalhealth from '../../../assets/images/chennaitambarammentalhealth.jpg';
import chennaitambarammenqr678 from '../../../assets/images/chennaitambaramqr678.jpg';

import hcuraHeroVideo from '../../../assets/video/hcura-hero2.mp4';
import hcuraHeroVideo1 from '../../../assets/video/hcura-hero6.mp4';
import hcuraHeroVideo2 from '../../../assets/video/hcura-hero4.mp4';

import chennaitambaramprpmicroneeding from "../../../assets/images/chennaitambaramprpmicroneeding1.jpg";
import chennaitambaramhairplan from "../../../assets/images/chennaitambaramhairplan.jpg";
import chennaitambaramlaserhair from "../../../assets/images/chennaitambaramlaserhair1.jpg";
import chennaitambarammainskin from "../../../assets/images/chennaitambarammainskin.jpg";
import chennaitambaramskinwhite from "../../../assets/images/chennaitambaramskinwhite.jpg";
import chennaitambaramhomeopathy1 from "../../../assets/images/chennaitambaramalopecia.jpg";
import chennaitambaramanxeity from "../../../assets/images/chennaitambaramanxeity.jpg";
import chennaitambarampiles from "../../../assets/images/chennaitambarampiles.jpg";
import chennaitambarammainhair from "../../../assets/images/chennaitamabarammainhair.jpg";
import chennaitambarammaindental from "../../../assets/images/chennaaitambarammaindental.jpg";
import chennaitambaramandental2 from "../../../assets/images/chennaitambaramandental3.jpg";
import chennaitambaramandental3 from "../../../assets/images/chennaitambaramandental4.jpg";
import chennaitambaramantiage1 from "../../../assets/images/chennaitambaramantiaging1.jpg";

const ICON_MAP = {
  'quality-icon': FaAward,
  'personalized-icon': FaUserCheck,
  'affordable-icon': FaCoins
};

const Icon = ({ name, size = 24, className = '', ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const HCuraChennai = () => {
  // SEO: Comprehensive Chennai areas for local SEO (200+ locations)
  const chennaLocationsSEO = {
    primaryAreas: [
      "Anna Nagar", "T Nagar", "Adyar", "Velachery", "Tambaram", "Chrompet", 
      "Porur", "Valasaravakkam", "Gerugambakkam", "Pallavaram", "Perungalathur",
      "Nungambakkam", "Mylapore", "Triplicane", "Egmore", "Chetpet", "Kilpauk",
      "Purasawalkam", "Washermanpet", "Royapuram", "Tondiarpet", "Madhavaram",
      "Ambattur", "Avadi", "Poonamallee", "Kundrathur", "Mangadu", "Maduravoyal",
      "Guindy", "Saidapet", "Alandur", "St Thomas Mount", "Pallikaranai",
      "Thoraipakkam", "Sholinganallur", "Medavakkam", "Selaiyur", "Chitlapakkam",
      "Pammal", "Anakaputhur", "Mudichur", "Vandalur", "Urapakkam", "Guduvanchery",
      "Koyambedu", "Vadapalani", "Ashok Nagar", "KK Nagar", "Jafferkhanpet",
      "Arumbakkam", "Virugambakkam", "Alwarthirunagar", "Ramapuram", "Mugalivakkam",
      "Pozhichalur", "Alapakkam", "Iyyappanthangal", "Perambur", "Villivakkam",
      "Korattur", "Thirumullaivoyal", "Pattabiram", "Thiruverkadu", "Mogappair",
      "Kolathur", "Vyasarpadi", "Mount Road", "Express Avenue", "Thousand Lights",
      "Teynampet", "Alwarpet", "Kotturpuram", "Raja Annamalai Puram", "Gopalapuram",
      "Boat Club", "Chepauk", "Mandaveli", "R A Puram", "Besant Nagar",
      "Thiruvanmiyur", "Indira Nagar", "Taramani", "Perungudi", "Kandanchavadi",
      "Injambakkam", "Kelambakkam", "Sithalapakkam", "Navalur", "Okkiyam Thoraipakkam",
      "Karapakkam", "Palavakkam", "Neelankarai", "Akkarai", "Uthandi", "Muttukadu",
      "Kovalam", "Mahabalipuram", "Chengalpattu", "Kanchipuram", "Sriperumbudur",
      "Oragadam", "Irungattukottai", "Walajabad", "Singaperumal Koil", "Maraimalai Nagar",
      "Chromepet", "Hasthinapuram", "Tambaram Sanatorium", "Sembakkam", "Rajakilpakkam",
      "Keelkattalai", "Madipakkam", "Siruseri", "Thiruporur", "Mamallapuram",
      "Red Hills", "Puzhal", "Tiruvallur", "Gummidipoondi", "Ennore", "Manali",
      "Minjur", "Sholavaram", "Nemam", "Ponneri", "Pulicat", "Thiruvottiyur",
      "Washermanpet", "Tondiarpet", "Royapuram", "Korukkupet", "Vyasarpadi",
      "Perambur", "Villivakkam", "Korattur", "Madhavaram", "Manali New Town",
      "Ennore", "Kathivakkam", "Minjur", "Pazhaverkadu", "Pulicat", "Gummidipoondi",
      "Ponneri", "Tiruvallur", "Avadi", "Ambattur", "Pattabiram", "Thirumazhisai",
      "Thirumullaivoyal", "Korattur", "Mogappair", "Nolambur", "Maduravoyal",
      "Poonamallee", "Kundrathur", "Mangadu", "Thiruverkadu", "Nazarathpet",
      "Porur", "Ramapuram", "Mugalivakkam", "Nandambakkam", "Valasaravakkam",
      "Virugambakkam", "Alwarthirunagar", "Ashok Nagar", "Vadapalani", "KK Nagar",
      "West Mambalam", "Kodambakkam", "Nungambakkam", "Chetpet", "Egmore",
      "Kilpauk", "Purasawalkam", "Perambur", "Vyasarpadi", "Washermanpet"
    ],
    nearbyDistricts: [
      "Kanchipuram", "Tiruvallur", "Chengalpattu", "Ranipet", "Tiruvannamalai",
      "Vellore", "Cuddalore", "Villupuram", "Thanjavur", "Trichy", "Madurai",
      "Coimbatore", "Salem", "Erode", "Tirupur", "Karur", "Namakkal", "Dharmapuri",
      "Krishnagiri", "Hosur", "Bangalore Rural", "Kolar", "Tumkur", "Hassan"
    ]
  };

  // Combine detailed location and service content for SEO purposes
  const seoLongDescription = `H-Cura is Chennai's most trusted multispecialty clinic, proudly serving patients from ${chennaLocationsSEO.primaryAreas.slice(0, 50).join(", ")} and over 200+ areas across Tamil Nadu including nearby districts like ${chennaLocationsSEO.nearbyDistricts.slice(0, 10).join(", ")}. We offer: Hair Treatment Chennai - All Areas Covered with Advanced PRP, GFC, Hair Transplant services. Skin Treatment Chennai - Dermatology Excellence including HydraFacial, Laser treatments, Anti-aging therapies. Dental Clinic Chennai - Complete Oral Care with Implants, Orthodontics, Smile Design. Homeopathy Chennai - Natural Healing for PCOS, Anxiety, Chronic disease treatment, and surrounding areas like Mogappair, Kolathur, Vyasarpadi, Mount Road, Express Avenue, Thousand Lights, Teynampet, Alwarpet, Kotturpuram, Raja Annamalai Puram, Gopalapuram, and surrounding Tamil Nadu areas.`;

  // SEO Constants - All SEO data defined before return
 const seoData = {
  title: " Best Multispeciality Clinic in Chennai | H-Cura Hair, Skin, Dental & Homeopathy",
  description: "H-Cura Multispeciality Clinic in Chennai offers advanced hair, skin, dental & homeopathy treatments. Expert care for lasting results. Book your appointment today.",
  keywords: "Multispeciality clinic Chennai, Hair clinic Chennai, Skin care clinic Chennai, Homeopathy clinic Chennai, Dental clinic Chennai, Advanced hair treatment Chennai, Hair fall treatment Chennai, PRP hair therapy Chennai, GFC hair therapy Chennai, Exosome hair treatment Chennai, Skin care treatment Chennai, Anti-aging treatment Chennai, HydraFacial Chennai, Facial treatments Chennai, Acne treatment Chennai, Hair growth treatment Chennai, Cosmetic dermatology Chennai, Holistic homeopathy Chennai, Chronic illness homeopathy Chennai, Allergy treatment Chennai, Painless dental treatment Chennai, Dental implants Chennai, Teeth whitening Chennai, Orthodontics Chennai, Oral health Chennai, Best clinic in Chennai, Top multispeciality clinic Chennai, H-Cura clinic Chennai",
  canonicalUrl: "https://www.h-cura.com/multispecialty-clinic-in-chennai/",
  ogTitle: "Best Multispecialty Clinic in Chennai Tamil Nadu | H-Cura Healthcare",
  ogDescription: "H-Cura Multispeciality Clinic in Chennai offers advanced hair, skin, dental & homeopathy treatments. Expert care for lasting results. Book your appointment today.",
  ogImage: "https://www.h-cura.com/images/hcura-chennai-clinic.jpg",
  ogUrl: "https://www.h-cura.com/multispecialty-clinic-in-chennai/",
  twitterTitle: "Best Multispecialty Clinic in Chennai | H-Cura",
  twitterDescription: "H-Cura Multispeciality Clinic in Chennai offers advanced hair, skin, dental & homeopathy treatments. Expert care for lasting results. Book your appointment today.",
  twitterImage: "https://www.h-cura.com/images/hcura-chennai-clinic.jpg",
  geoRegion: "IN-TN",
  geoPlacename: "Chennai, Tamil Nadu, India",
  geoPosition: "13.0827;80.2707",
  icbm: "13.0827, 80.2707",
  location: "Chennai, Tamil Nadu, India",
  siteName: "H-Cura Multispecialty Clinic",
  author: "H-Cura Multispecialty Clinic",
  robots: "index, follow",
  language: "English",
  revisitAfter: "7 days",
  contentType: "text/html; charset=utf-8",
  viewport: "width=device-width, initial-scale=1.0"
};


  // JSON-LD Schema for Local Business
 const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalClinic",
  "name": "H-Cura Multispecialty Clinic Chennai",
  "description": "H-Cura Multispeciality Clinic in Chennai offers advanced hair, skin, dental & homeopathy treatments. Expert care for lasting results. Book your appointment today.",
  // ... rest of your schema
};


  // Medical Organization Schema
  const medicalOrganizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "H-Cura Multispecialty Clinic",
    "alternateName": "H-Cura Chennai",
    "url": "https://h-cura.com/multispecialty-clinic-in-chennai/",
    "logo": "https://h-cura.com/images/h-cura-logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-88700-01377",
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["English", "Tamil", "Hindi"]
    },
    "sameAs": [
      "https://www.facebook.com/hcuraclinic",
      "https://www.instagram.com/hcuraclinic",
      "https://www.youtube.com/hcuraclinic"
    ]
  };

  const [activeLocation, setActiveLocation] = useState('tambaram');
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);

  // NEW: auto-scroll state and ref
  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  // Modal / viewer state (chennai-prefixed)
  const [chennaiBaModalOpen, setChennaiBaModalOpen] = useState(false);
  const [chennaiBaModalItems, setChennaiBaModalItems] = useState([]);
  const [chennaiBaModalStartIndex, setChennaiBaModalStartIndex] = useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Add these scrolling functions inside your component
  const scrollGallery = (direction) => {
    const container = document.getElementById('scrollableGrid');
    const cardWidth = 420; // Width of each card + gap
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    let newScrollPosition;
    if (direction === 'next') {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }

    container.scrollTo({
      left: newScrollPosition,
      behavior: 'smooth'
    });

    updateScrollIndicators();
  };

  const updateScrollIndicators = () => {
    const container = document.getElementById('scrollableGrid');
    const progressBar = document.getElementById('progressBar');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    if (!container || !progressBar) return;

    const scrollPercentage = (container.scrollLeft / (container.scrollWidth - container.clientWidth)) * 100;
    progressBar.style.width = `${scrollPercentage}%`;

    // Update button states
    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = container.scrollLeft >= (container.scrollWidth - container.clientWidth - 10);
  };

  // Comprehensive SEO useEffect
  useEffect(() => {
    // Set document title
    document.title = seoData.title;
    
    // Set meta description
    let metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", seoData.description);
    } else {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      metaDescription.setAttribute("content", seoData.description);
      document.head.appendChild(metaDescription);
    }
    
    // Set meta keywords
    let metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute("content", seoData.keywords);
    } else {
      metaKeywords = document.createElement("meta");
      metaKeywords.setAttribute("name", "keywords");
      metaKeywords.setAttribute("content", seoData.keywords);
      document.head.appendChild(metaKeywords);
    }
    
    // Set canonical link
    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute("href", seoData.canonicalUrl);
    } else {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", seoData.canonicalUrl);
      document.head.appendChild(canonicalLink);
    }
    
    // Set favicon
    let faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
      faviconLink.setAttribute("href", favicon);
    } else {
      faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add JSON-LD structured data
    let schemaScript = document.querySelector('script[type="application/ld+json"]');
    if (schemaScript) {
      schemaScript.textContent = JSON.stringify([localBusinessSchema, medicalOrganizationSchema]);
    } else {
      schemaScript = document.createElement('script');
      schemaScript.type = 'application/ld+json';
      schemaScript.textContent = JSON.stringify([localBusinessSchema, medicalOrganizationSchema]);
      document.head.appendChild(schemaScript);
    }

    // Add Open Graph meta tags
    const ogTags = [
      { property: 'og:title', content: seoData.ogTitle },
      { property: 'og:description', content: seoData.ogDescription },
      { property: 'og:type', content: 'business.business' },
      { property: 'og:url', content: seoData.ogUrl },
      { property: 'og:image', content: seoData.ogImage },
      { property: 'og:site_name', content: seoData.siteName },
      { property: 'og:locale', content: 'en_IN' }
    ];

    ogTags.forEach(tag => {
      let existingTag = document.querySelector(`meta[property='${tag.property}']`);
      if (existingTag) {
        existingTag.setAttribute('content', tag.content);
      } else {
        const newTag = document.createElement('meta');
        newTag.setAttribute('property', tag.property);
        newTag.setAttribute('content', tag.content);
        document.head.appendChild(newTag);
      }
    });

    // Add Twitter Card meta tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: seoData.twitterTitle },
      { name: 'twitter:description', content: seoData.twitterDescription },
      { name: 'twitter:image', content: seoData.twitterImage }
    ];

    twitterTags.forEach(tag => {
      let existingTag = document.querySelector(`meta[name='${tag.name}']`);
      if (existingTag) {
        existingTag.setAttribute('content', tag.content);
      } else {
        const newTag = document.createElement('meta');
        newTag.setAttribute('name', tag.name);
        newTag.setAttribute('content', tag.content);
        document.head.appendChild(newTag);
      }
    });

    // Add geo meta tags
    const geoTags = [
      { name: 'geo.region', content: seoData.geoRegion },
      { name: 'geo.placename', content: seoData.geoPlacename },
      { name: 'geo.position', content: seoData.geoPosition },
      { name: 'ICBM', content: seoData.icbm },
      { name: 'location', content: seoData.location },
      { name: 'coverage', content: seoData.location }
    ];

    geoTags.forEach(tag => {
      let existingTag = document.querySelector(`meta[name='${tag.name}']`);
      if (existingTag) {
        existingTag.setAttribute('content', tag.content);
      } else {
        const newTag = document.createElement('meta');
        newTag.setAttribute('name', tag.name);
        newTag.setAttribute('content', tag.content);
        document.head.appendChild(newTag);
      }
    });

    // Add additional SEO meta tags
    const additionalTags = [
      { name: 'robots', content: seoData.robots },
      { name: 'author', content: seoData.author },
      { name: 'language', content: seoData.language },
      { name: 'revisit-after', content: seoData.revisitAfter },
      { httpEquiv: 'Content-Type', content: seoData.contentType }
    ];

    additionalTags.forEach(tag => {
      const selector = tag.httpEquiv ? `meta[http-equiv='${tag.httpEquiv}']` : `meta[name='${tag.name}']`;
      let existingTag = document.querySelector(selector);
      if (existingTag) {
        existingTag.setAttribute('content', tag.content);
      } else {
        const newTag = document.createElement('meta');
        if (tag.httpEquiv) {
          newTag.setAttribute('http-equiv', tag.httpEquiv);
        } else {
          newTag.setAttribute('name', tag.name);
        }
        newTag.setAttribute('content', tag.content);
        document.head.appendChild(newTag);
      }
    });

  }, [seoData, localBusinessSchema, medicalOrganizationSchema]);

  // Add scroll event listener when modal opens
  useEffect(() => {
    if (chennaiBaModalOpen) {
      const container = document.getElementById('scrollableGrid');
      if (container) {
        container.addEventListener('scroll', updateScrollIndicators);
        updateScrollIndicators(); // Initial call

        // Initial scroll to startIndex
        const cardWidth = 420; // Ensure this matches your CSS card width + gap
        container.scrollLeft = chennaiBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener('scroll', updateScrollIndicators);
        };
      }
    }
  }, [chennaiBaModalOpen, chennaiBaModalStartIndex]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start('visible');
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Update the useEffect for auto-scroll to keep it within advancedServices bounds
useEffect(() => {
  // Clear any existing interval
  if (autoScrollRef.current) {
    clearInterval(autoScrollRef.current);
    autoScrollRef.current = null;
  }

  if (!isAutoScrollPaused) {
    autoScrollRef.current = setInterval(() => {
      setActiveService(prev => {
        const next = (prev + 1) % advancedServices.length; // Keep it within advancedServices bounds
        // Follow same change animation behavior
        setIsChanging(true);
        setTimeout(() => {
          setIsChanging(false);
        }, 300);
        return next;
      });
    }, 3000); // 3 seconds for faster scrolling
  }

  return () => {
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }
  };
}, [isAutoScrollPaused]);

// Add a separate state for testimonial scrolling
const [activeTestimonial, setActiveTestimonial] = useState(0);
const testimonialScrollRef = useRef(null);

// Add a separate useEffect for testimonial auto-scroll
useEffect(() => {
  // Clear any existing interval
  if (testimonialScrollRef.current) {
    clearInterval(testimonialScrollRef.current);
    testimonialScrollRef.current = null;
  }

  testimonialScrollRef.current = setInterval(() => {
    setActiveTestimonial(prev => (prev + 1) % 10); // Cycle through all 10 testimonials
  }, 3000); // 3 seconds

  return () => {
    if (testimonialScrollRef.current) {
      clearInterval(testimonialScrollRef.current);
      testimonialScrollRef.current = null;
    }
  };
}, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12,
      },
    },
  };

  const locations = {
    tambaram: {
      name: "Tambaram",
      address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
      phone: "+91 88700 01377",
      hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
      nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
      popularServices: [
        "PRP Hair Treatment",
        "Dental Fillings",
        "Acne & Skin Lightening",
        "Root Canal and Smile Design"
      ],
      specialties: "Hair Restoration & Dental Procedures",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai",
      video: hcuraHeroVideo1
    },
    valasaravakkam: {
      name: "Valasaravakkam",
      address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
      phone: "+91 88700 01377",
      hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
      nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
      popularServices: [
        "Braces and Orthodontics",
        "GFC Hair Therapy",
        "Pigmentation & Skin Whitening",
        "Anxiety & PCOS Homeopathy Treatment"
      ],
      specialties: "Skin Treatments & Women's Health",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai",
      video: hcuraHeroVideo1
    },
    gerugambakkam: {
      name: "Gerugambakkam",
      address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
      phone: "+91 88700 01377",
      hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
      nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
      popularServices: [
        "Hair Loss Treatment",
        "Skin Problem Solutions",
        "Complete Dental Care",
        "Natural Homeopathy Treatment"
      ],
      specialties: "Complete Healthcare Solutions",
      mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai",
      video: hcuraHeroVideo1
    }
  };

  const advancedServices = [
    {
      id: "hair",
      title:
        "Advanced Hair Treatments in Chennai – PRP + Microneedling & GFC Therapy",
      subtitle: "Restore Your Hair, Rebuild Your Confidence",
      description:
        "Experience the most advanced hair restoration treatments in Chennai. Our expert trichologists use cutting-edge PRP + Microneedling and GFC therapy to give you natural, lasting results.",
      image: chennaitambarammainhair,
      treatments: [
        {
          name: "PRP + Microneedling Hair Treatment Chennai",
          description:
            "Advanced Platelet-Rich Plasma therapy combined with microneedling using your own blood to naturally stimulate hair growth and strengthen follicles.",
          icon: "prp-icon",
          image: chennaitambaramprpmicroneeding,
          benefits: [
            "Natural hair regrowth",
            "Stronger hair follicles",
            "No side effects",
            "Quick treatment sessions",
          ],
        },
        {
          name: "GFC Hair Therapy Chennai",
          description:
            "Revolutionary Growth Factor Concentrate therapy that accelerates hair regeneration with concentrated growth factors from your blood.",
          icon: "gfc-icon",
          image: chennaitambaramgfc,
          benefits: [
            "Faster hair regrowth",
            "Increased hair density",
            "Natural-looking results",
            "Personalized treatment",
          ],
        },
        {
          name: "Hair Fall Control Plans Chennai",
          description:
            "Complete hair fall treatment plans that find out why your hair is falling and create a personal plan to stop hair loss and help new hair grow back healthy.",
          icon: "prp-icon",
          image: chennaitambaramhairplan,
          benefits: [
            "Full hair check-up",
            "Custom treatment plan",
            "Long-lasting results",
            "Doctor monitoring",
          ],
        },
      ],
      testimonial: {
        quote:
          "After trying many treatments elsewhere, H-Cura Chennai's PRP and GFC combination gave me amazing results. My hair is thicker and healthier than ever!",
        author: "Priya S.",
        location: "Chennai",
      },
    },
    {
      id: "skin",
      title: "Skin Treatments in Chennai – From Acne to Anti-Aging",
      subtitle: "Reveal Your Natural Glow",
      description:
        "Transform your skin with our advanced dermatology treatments in Chennai. From acne solutions to anti-aging therapies, we help you achieve radiant, healthy skin.",
      image: chennaitambarammainskin,
      treatments: [
        {
          name: "Laser Hair Removal Treatment Chennai",
          description:
            "Advanced laser technology that permanently reduces unwanted hair growth with precise targeting for smooth, hair-free skin.",
          icon: "laser-hair-removal-icon",
          image: chennaitambaramlaserhair,
          benefits: [
            "Permanent hair reduction",
            "Smooth, silky skin",
            "Minimal discomfort",
            "Suitable for all skin types",
          ],
        },
        {
          name: "Skin Whitening Chennai",
          description:
            "Safe and effective skin lightening treatments that reduce dark spots, melasma, and uneven skin tone for a brighter complexion.",
          icon: "pigmentation-icon",
          image: chennaitambaramskinwhite,
          benefits: [
            "Even skin tone",
            "Reduced dark spots",
            "Brighter complexion",
            "Safe treatments",
          ],
        },
        {
          name: "Anti-Aging Treatment Chennai",
          description:
            "Comprehensive anti-aging program using collagen therapy, antioxidant treatments, and advanced peptide solutions for youthful skin.",
          icon: "pigmentation-icon",
          image: chennaitambaramantiage1,
          benefits: [
            "Reduced fine lines",
            "Improved skin elasticity",
            "Enhanced collagen production",
            "Youthful appearance",
          ],
        },
      ],
      testimonial: {
        quote:
          "The skin whitening treatment at H-Cura Chennai gave me the even skin tone I always wanted. The results are amazing and completely natural!",
        author: "Kavya M.",
        location: "Porur",
      },
    },
    {
      id: "dental",
      title: "Dental Care in Chennai – Advanced & Painless",
      subtitle: "Perfect Smiles Made Simple",
      description:
        "Experience world-class dental care in Chennai with our advanced, painless treatments. From routine checkups to complete smile makeovers.",
      image: chennaitambarammaindental,
      treatments: [
        {
          name: "Pediatric Dentistry Treatments",
          description:
            "Comprehensive dental care for children including preventive treatments, cavity fillings, and specialized procedures designed for young patients in a comfortable environment.",
          icon: "smile-icon",
          image: chennaitambaramandental1,
          benefits: [
            "Child-friendly approach",
            "Preventive care focus",
            "Gentle procedures",
            "Early intervention",
          ],
        },
        {
          name: "Dental Implants Chennai",
          description:
            "Replace missing teeth with permanent, natural-looking dental implants using the latest technology for comfortable, lasting results.",
          icon: "rootcanal-icon",
          image: chennaitambaramandental2,
          benefits: [
            "Permanent solution",
            "Natural appearance",
            "Comfortable fit",
            "Long-lasting results",
          ],
        },

        {
          name: "Advanced Smile Design Chennai",
          description:
            "Transform your smile with comprehensive cosmetic dentistry including veneers, whitening, and digital smile planning for perfect results.",
          icon: "aligner-icon",
          image: chennaitambaramandental3,
          benefits: [
            "Complete smile makeover",
            "Enhanced aesthetics",
            "Digital planning",
            "Personalized results",
          ],
        },
      ],
      testimonial: {
        quote:
          "The dental implant procedure at H-Cura Chennai was completely painless. My new teeth look and feel completely natural!",
        author: "Rajesh K.",
        location: "Mangadu",
      },
    },
    {
      id: "homeopathy",
      title: "Homeopathy in Chennai – Natural Healing for Women",
      subtitle: "Natural Solutions for Better Health",
      description:
        "Discover the power of natural healing with our specialized homeopathy treatments in Chennai, focusing on women's health and chronic conditions.",
      image: chennaitambaramhomeopathy,
      treatments: [
        {
          name: "Alopecia Areata Treatment Chennai",
          description:
            "Effective homeopathic treatment for alopecia areata that stimulates hair regrowth, strengthens hair follicles, and addresses underlying causes naturally.",
          icon: "constitutional-icon",
          image: chennaitambaramhomeopathy1,
          benefits: [
            "Hair regrowth stimulation",
            "Natural treatment",
            "No side effects",
            "Long-term results",
          ],
        },
        {
          name: "Anxiety Treatment Chennai",
          description:
            "Complete anxiety care using natural homeopathic medicines to calm your mind, reduce worry, and help you feel better naturally.",
          icon: "mental-health-icon",
          image: chennaitambaramanxeity,
          benefits: [
            "Less worry",
            "Better sleep",
            "Natural calming",
            "Personal care",
          ],
        },

        {
          name: "Piles Treatment Chennai",
          description:
            "Specialized homeopathic treatments for piles including pain relief, bleeding control, and complete healing without surgery.",
          icon: "chronic-icon",
          image: chennaitambarampiles,
          benefits: [
            "Pain relief",
            "No surgery needed",
            "Expert guidance",
            "Natural remedies",
          ],
        },
      ],
      testimonial: {
        quote:
          "H-Cura Chennai's homeopathic treatment for PCOS has completely changed my life. My cycles are regular and I feel so much healthier!",
        author: "Divya R.",
        location: "Chennai",
      },
    },
  ];

const testimonials = [
  // Hair Treatment Testimonials
  {
    name: "Rajesh K.",
    location: "Anna Nagar",
    text: "The PRP + Microneedling treatment at H-Cura Chennai gave me amazing hair regrowth results. My hairline is back and I feel so confident now!",
    rating: 5,
    service: "PRP Hair Treatment"
  },
  {
    name: "Deepak V.",
    location: "Tambaram",
    text: "GFC Hair Therapy at H-Cura Chennai worked wonders for my hair loss. Natural results with no side effects. Highly recommend this treatment!",
    rating: 5,
    service: "GFC Hair Therapy"
  },
  {
    name: "Anitha L.",
    location: "Velachery",
    text: "The Hair Fall Control Plan helped me understand my hair problems completely. Now my hair is stronger and healthier than ever before!",
    rating: 5,
    service: "Hair Fall Control"
  },
  
  // Skin Treatment Testimonials
  {
    name: "Meera S.",
    location: "T. Nagar",
    text: "Laser Hair Removal at H-Cura Chennai was painless and effective. My skin is now smooth and hair-free. Best decision I made!",
    rating: 5,
    service: "Laser Hair Removal"
  },
  {
    name: "Kavya M.",
    location: "Porur",
    text: "The Skin Whitening treatment gave me the even skin tone I always wanted. The results are amazing and completely natural looking!",
    rating: 5,
    service: "Skin Whitening"
  },
  {
    name: "Preethi S.",
    location: "Adyar",
    text: "Anti-Aging treatment at H-Cura Chennai reduced my fine lines beautifully. I look years younger and feel more confident now!",
    rating: 5,
    service: "Anti-Aging Treatment"
  },
  
  // Dental Treatment Testimonials
  {
    name: "Karthik R.",
    location: "Gerugambakkam",
    text: "The Pediatric Dentistry care for my child was exceptional. The doctors are gentle and my child no longer fears dental visits!",
    rating: 5,
    service: "Pediatric Dentistry"
  },
  {
    name: "Suresh M.",
    location: "Valasaravakkam",
    text: "Dental Implants at H-Cura Chennai look and feel completely natural. The procedure was painless and the results are perfect!",
    rating: 5,
    service: "Dental Implants"
  },
  {
    name: "Vikram P.",
    location: "Chrompet",
    text: "Advanced Smile Design transformed my smile completely. The digital planning made everything perfect. I'm so happy with my new smile!",
    rating: 5,
    service: "Smile Design"
  },
  
  // Homeopathy Treatment Testimonials
  {
    name: "Divya R.",
    location: "Nungambakkam",
    text: "Alopecia Areata treatment with homeopathy at H-Cura Chennai brought back my hair naturally. No side effects, just great results!",
    rating: 5,
    service: "Alopecia Treatment"
  }
];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Easy to Reach Locations",
      description: "Our clinics are located in convenient places across Chennai. Easy to reach from Anna Nagar, T. Nagar, Adyar, Velachery, and all major areas with good bus and train connections.",
      highlight: "Convenient Locations"
    },
    {
      icon: <FaUserMd />,
      title: "Experienced Doctors",
      description: "Chennai's best doctors for hair, skin, teeth, and natural medicine. All our doctors have many years of experience and have helped thousands of patients.",
      highlight: "Expert Doctors"
    },
    {
      icon: <GiMedicalPack />,
      title: "Modern Equipment",
      description: "We use the latest machines and technology for all treatments. Our equipment is safe, modern, and gives the best results for our patients.",
      highlight: "Latest Technology"
    },
    {
      icon: <FaHeartbeat />,
      title: "Complete Health Care",
      description: "Get all your health treatments in one place. From beauty treatments to serious health problems, we take care of everything under one roof.",
      highlight: "Complete Care"
    },
    {
      icon: <FaAward />,
      title: "Trusted by Many",
      description: "Thousands of happy patients across Chennai trust us. We are known as Chennai's best clinic with excellent results and satisfied patients.",
      highlight: "Award Winning"
    },
    {
      icon: <FaRegLightbulb />,
      title: "Treatment Made for You",
      description: "Every patient is different, so we make special treatment plans just for you. We consider your health, lifestyle, and what you want to achieve.",
      highlight: "Personal Care"
    },
    {
      icon: <FaUserCheck />,
      title: "We Follow Up with You",
      description: "After your treatment, we keep checking how you're doing. We make sure you're healing well and getting the results you want.",
      highlight: "Continuous Care"
    },
    {
      icon: <FaUsers />,
      title: "Comfortable and Clean",
      description: "Our clinics are clean, comfortable, and welcoming. We have private rooms for consultations and modern facilities that make you feel relaxed and safe.",
      highlight: "Patient Comfort"
    }
  ];

  const testimonialQuotes = [
    "H-Cura Chennai combines the best modern medicine with natural healing.",
    "The care and expertise at H-Cura Chennai is the best in the city.",
    "From consultation to recovery, H-Cura Chennai provides world-class medical care."
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  // helper to map service id to the proper Learn More page
  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case 'hair': return '/advanced-grow-hair-treatment';
      case 'skin': return '/advanced-hydrafacial-treatment';
      case 'dental': return '/dental-treatment';
      case 'homeopathy': return '/homeopathy-best-treatments/';
      default: return '/services';
    }
  };

  /*
    IMAGE / ICON MANAGEMENT (moved here into JSX inline styles)
    We map all image URLs used previously in CSS into JS maps and apply inline styles where those images were used.
  */
  const heroBackgroundUrl = tambarambanner3;
  const servicesBackgroundUrl = 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80';

  // icons for service tabs (same icons previously set in CSS background-image)
  const serviceIconMap = {
    hair: {
      url: tambaramhair,
      bgColor: 'rgba(255,154,158,0.12)',
      borderColor: 'rgba(255,154,158,0.18)',
      color: '#ff4d6d'
    },
    skin: {
      url: chennaiiiskin,
      bgColor: 'rgba(255,223,121,0.12)',
      borderColor: 'rgba(255,223,121,0.18)',
      color: '#ffb400'
    },
    dental: {
      url: 'https://img.icons8.com/fluency/48/000000/tooth.png',
      bgColor: 'rgba(144,238,144,0.12)',
      borderColor: 'rgba(144,238,144,0.18)',
      color: '#28a745'
    },
    homeopathy: {
      url: tambaramleaf,
      bgColor: 'rgba(135,206,250,0.12)',
      borderColor: 'rgba(135,206,250,0.18)',
      color: '#0099cc'
    }
  };

  // treatment bright icons (previously background-image in CSS)
  const treatmentIconMap = {
    'prp-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/syringe.png',
      bgColor: 'rgba(255,140,140,0.06)',
      borderColor: 'rgba(255,140,140,0.12)'
    },
    'gfc-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/biotech.png',
      bgColor: 'rgba(170,200,255,0.06)',
      borderColor: 'rgba(110,160,255,0.12)'
    },
    'transplant-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hair-care.png',
      bgColor: 'rgba(255,230,140,0.06)',
      borderColor: 'rgba(255,200,60,0.12)'
    },
    'hydrafacial-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/spa-care.png',
      bgColor: 'rgba(200,255,230,0.06)',
      borderColor: 'rgba(60,200,120,0.12)'
    },
    'pigmentation-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/foundation-makeup.png',
      bgColor: 'rgba(250,210,255,0.06)',
      borderColor: 'rgba(220,120,240,0.12)'
    },
    'antiaging-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/collagen.png',
      bgColor: 'rgba(220,245,255,0.06)',
      borderColor: 'rgba(80,200,240,0.12)'
    },
    'smile-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/happy-tooth.png',
      bgColor: 'rgba(200,255,220,0.06)',
      borderColor: 'rgba(80,200,120,0.12)'
    },
    'rootcanal-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/tooth-cleaning.png',
      bgColor: 'rgba(255,240,200,0.06)',
      borderColor: 'rgba(240,180,60,0.12)'
    },
    'aligner-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/braces.png',
      bgColor: 'rgba(230,230,255,0.06)',
      borderColor: 'rgba(140,120,240,0.12)'
    },
    'constitutional-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/holistic-therapy.png',
      bgColor: 'rgba(240,240,255,0.06)',
      borderColor: 'rgba(160,160,240,0.12)'
    },
    'hormonal-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hormone.png',
      bgColor: 'rgba(255,230,240,0.06)',
      borderColor: 'rgba(240,160,200,0.12)'
    },
    'chronic-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/medical-pack.png',
      bgColor: 'rgba(230,255,240,0.06)',
      borderColor: 'rgba(160,240,200,0.12)'
    },
    'qr678-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hair-care.png',
      bgColor: 'rgba(255,230,140,0.06)',
      borderColor: 'rgba(255,200,60,0.12)'
    }
  };

  // SAMPLE gallery (10 per service) - correct syntax
  const SAMPLE_GALLERY = {
    hair: [
      {
        id: 'hair-1',
        title: 'Hair Case 1 - Male Pattern Baldness',
        combined: img1,
        testimonial: { quote: 'Amazing hair transformation in just 6 months with PRP treatment!', author: 'Rajesh K.' }
      },
      {
        id: 'hair-2',
        title: 'Hair Case 2 - Crown Area Restoration',
        combined: img2,
        testimonial: { quote: 'PRP and GFC therapy gave me incredible results. Highly recommend!', author: 'Amit S.' }
      },
      {
        id: 'hair-3',
        title: 'Hair Case 3 - Receding Hairline Treatment',
        combined: img3,
        testimonial: { quote: 'My confidence is back with my natural-looking hairline!', author: 'Priya M.' }
      },
      {
        id: 'hair-4',
        title: 'Hair Case 4 - Hair Regrowth Success',
        combined: img4,
        testimonial: { quote: 'GFC therapy worked wonders for my extensive hair loss problem.', author: 'Karthik R.' }
      },
      {
        id: 'hair-5',
        title: 'Hair Case 5 - Natural Hair Regrowth',
        combined: img5,
        testimonial: { quote: 'Best decision I made for my hair health. Natural results!', author: 'Deepak V.' }
      },
      {
        id: 'hair-6',
        title: 'Hair Case 6 - Hair Density Improvement',
        combined: img6,
        testimonial: { quote: 'Visible hair density increase within 3 months of treatment.', author: 'Anitha L.' }
      },
      {
        id: 'hair-7',
        title: 'Hair Case 7 - Complete Hair Makeover',
        combined: img7,
        testimonial: { quote: 'Professional treatment with amazing outcomes. Thank you H-Cura!', author: 'Suresh K.' }
      },
      {
        id: 'hair-8',
        title: 'Hair Case 8 - Hairline Restoration',
        combined: img8,
        testimonial: { quote: 'My family is amazed by the complete transformation.', author: 'Vikram P.' }
      },
      {
        id: 'hair-9',
        title: 'Hair Case 9 - Hair Volume Enhancement',
        combined: img9,
        testimonial: { quote: 'H-Cura gave me back my youthful appearance and confidence.', author: 'Ramesh B.' }
      },
      {
        id: 'hair-10',
        title: 'Hair Case 10 - Hair Thickness Treatment',
        combined: img10,
        testimonial: { quote: 'Outstanding results that exceeded all my expectations!', author: 'Mahesh T.' }
      }
    ],

    skin: [
      {
        id: 'skin-1',
        title: 'Skin Case 1 - Acne Treatment',
        combined: img11,
        testimonial: { quote: 'Clear skin after years of struggling with acne!', author: 'Sneha R.' }
      },
      {
        id: 'skin-2',
        title: 'Skin Case 2 - Pigmentation Removal',
        combined: img12,
        testimonial: { quote: 'HydraFacial gave me the glow I always wanted.', author: 'Kavya M.' }
      },
      {
        id: 'skin-3',
        title: 'Skin Case 3 - Anti-Aging Treatment',
        combined: img13,
        testimonial: { quote: 'Wrinkles reduced significantly with laser treatment.', author: 'Meera K.' }
      },
      {
        id: 'skin-4',
        title: 'Skin Case 4 - Skin Whitening',
        combined: img14,
        testimonial: { quote: 'Even skin tone achieved naturally and safely.', author: 'Preethi S.' }
      },
      {
        id: 'skin-5',
        title: 'Skin Case 5 - Melasma Treatment',
        combined: img15,
        testimonial: { quote: 'Dark patches completely gone after treatment!', author: 'Divya L.' }
      },
      {
        id: 'skin-6',
        title: 'Skin Case 6 - Skin Rejuvenation',
        combined: img16,
        testimonial: { quote: 'Youthful skin restored with advanced treatments.', author: 'Anjali P.' }
      },
      {
        id: 'skin-7',
        title: 'Skin Case 7 - Acne Scar Removal',
        combined: img17,
        testimonial: { quote: 'Smooth skin texture achieved after scar treatment.', author: 'Rohit M.' }
      },
      {
        id: 'skin-8',
        title: 'Skin Case 8 - Dark Circle Treatment',
        combined: img18,
        testimonial: { quote: 'Bright, refreshed eyes after under-eye treatment.', author: 'Lakshmi V.' }
      },
      {
        id: 'skin-9',
        title: 'Skin Case 9 - Skin Tightening',
        combined: img19,
        testimonial: { quote: 'Firm, tight skin without surgery. Amazing results!', author: 'Sunita K.' }
      },
      {
        id: 'skin-10',
        title: 'Skin Case 10 - Overall Skin Health',
        combined: img20,
        testimonial: { quote: 'Complete skin transformation with holistic approach.', author: 'Ravi S.' }
      }
    ],

    dental: [
      {
        id: 'dental-1',
        title: 'Dental Case 1 - Smile Makeover',
        combined: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Perfect smile achieved with digital smile design!', author: 'Arun K.' }
      },
      {
        id: 'dental-2',
        title: 'Dental Case 2 - Teeth Whitening',
        combined: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Bright, white teeth in just one session!', author: 'Priya R.' }
      },
      {
        id: 'dental-3',
        title: 'Dental Case 3 - Dental Implants',
        combined: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Natural-looking teeth replacement. Excellent work!', author: 'Suresh M.' }
      },
      {
        id: 'dental-4',
        title: 'Dental Case 4 - Orthodontic Treatment',
        combined: 'https://images.unsplash.com/photo-1601568544619-9e77545a0c94?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Straight teeth with invisible braces. Amazing!', author: 'Kavitha S.' }
      },
      {
        id: 'dental-5',
        title: 'Dental Case 5 - Root Canal Treatment',
        combined: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Painless root canal treatment. Saved my tooth!', author: 'Ramesh P.' }
      },
      {
        id: 'dental-6',
        title: 'Dental Case 6 - Gum Treatment',
        combined: 'https://images.unsplash.com/photo-1542736667-069246bdbc6d?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Healthy gums restored with laser treatment.', author: 'Deepa L.' }
      },
      {
        id: 'dental-7',
        title: 'Dental Case 7 - Crown & Bridge',
        combined: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Perfect fit crowns. Natural appearance achieved!', author: 'Vikram R.' }
      },
      {
        id: 'dental-8',
        title: 'Dental Case 8 - Cosmetic Dentistry',
        combined: 'https://images.unsplash.com/photo-1555708982-8645ec6618c7?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete smile transformation. Confidence restored!', author: 'Anitha M.' }
      },
      {
        id: 'dental-9',
        title: 'Dental Case 9 - Pediatric Dentistry',
        combined: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Child-friendly treatment. No more dental fear!', author: 'Sita K.' }
      },
      {
        id: 'dental-10',
        title: 'Dental Case 10 - Full Mouth Rehabilitation',
        combined: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete oral health restored. Life-changing results!', author: 'Mahesh V.' }
      }
    ],

    homeopathy: [
      {
        id: 'homeopathy-1',
        title: 'Homeopathy Case 1 - PCOS Treatment',
        combined: 'https://images.unsplash.com/photo-1577003833619-76bbd7f82948?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Natural PCOS treatment regulated my cycles perfectly!', author: 'Divya R.' }
      },
      {
        id: 'homeopathy-2',
        title: 'Homeopathy Case 2 - Chronic Illness',
        combined: 'https://images.unsplash.com/photo-1505751171710-1f6d0ace5a85?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Holistic approach cured my chronic condition naturally.', author: 'Raj M.' }
      },
      {
        id: 'homeopathy-3',
        title: 'Homeopathy Case 3 - Infertility Treatment',
        combined: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Blessed with a baby after homeopathic treatment!', author: 'Preethi S.' }
      },
      {
        id: 'homeopathy-4',
        title: 'Homeopathy Case 4 - Anxiety Treatment',
        combined: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Mental peace achieved through natural remedies.', author: 'Arjun K.' }
      },
      {
        id: 'homeopathy-5',
        title: 'Homeopathy Case 5 - Digestive Issues',
        combined: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Digestive problems resolved without side effects.', author: 'Meera L.' }
      },
      {
        id: 'homeopathy-6',
        title: 'Homeopathy Case 6 - Skin Allergies',
        combined: 'https://images.unsplash.com/photo-1594824111567-8b5d7e0d5ad6?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Chronic skin allergies cured permanently!', author: 'Sundar R.' }
      },
      {
        id: 'homeopathy-7',
        title: 'Homeopathy Case 7 - Respiratory Issues',
        combined: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Breathing problems resolved with gentle treatment.', author: 'Lakshmi P.' }
      },
      {
        id: 'homeopathy-8',
        title: 'Homeopathy Case 8 - Joint Pain Relief',
        combined: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Arthritis pain reduced significantly without drugs.', author: 'Raman V.' }
      },
      {
        id: 'homeopathy-9',
        title: 'Homeopathy Case 9 - Migraine Treatment',
        combined: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Chronic migraines eliminated with homeopathy.', author: 'Kavya M.' }
      },
      {
        id: 'homeopathy-10',
        title: 'Homeopathy Case 10 - Overall Wellness',
        combined: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete health transformation through natural healing.', author: 'Deepak S.' }
      }
    ]
  };

  // autoplay toggle state per thumbnail: before -> after every ~5s
  const [thumbnailFlipState, setThumbnailFlipState] = useState({
    hair: Array(10).fill(false),
    skin: Array(10).fill(false),
    dental: Array(10).fill(false),
    homeopathy: Array(10).fill(false)
  });

  useEffect(() => {
    const timers = [];
    Object.keys(SAMPLE_GALLERY).forEach((svcKey) => {
      SAMPLE_GALLERY[svcKey].forEach((_, idx) => {
        const t = setInterval(() => {
          setThumbnailFlipState(prev => {
            const copy = { ...prev };
            copy[svcKey] = copy[svcKey].slice();
            copy[svcKey][idx] = !copy[svcKey][idx];
            return copy;
          });
        }, 5000 + idx * 250);
        timers.push(t);
      });
    });
    return () => timers.forEach(t => clearInterval(t));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openChennaiBaModal = (serviceKey, startIndex = 0) => {
    setChennaiBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setChennaiBaModalStartIndex(startIndex);
    setChennaiBaModalOpen(true);
    document.body.style.overflow = 'hidden';
    // Initial scroll will be handled by useEffect now
  };

  const closeChennaiBaModal = () => {
    setChennaiBaModalOpen(false);
    setChennaiBaModalItems([]);
    setChennaiBaModalStartIndex(0);
    document.body.style.overflow = '';
  };

  return (
    <>
      {/* SEO: Enhanced Helmet with comprehensive meta tags */}
      <Helmet>
        {/* Primary SEO Meta Tags */}
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        
        {/* SEO: Comprehensive Keywords */}
        <meta name="keywords" content={seoData.keywords} />
        
        {/* Canonical URL */}
<link rel="canonical" href="https://www.h-cura.com/multispecialty-clinic-in-chennai/" />
        
        {/* SEO: Location-specific meta tags */}
        <meta name="geo.region" content={seoData.geoRegion} />
        <meta name="geo.placename" content={seoData.geoPlacename} />
        <meta name="geo.position" content={seoData.geoPosition} />
        <meta name="ICBM" content={seoData.icbm} />
        <meta name="location" content={seoData.location} />
        <meta name="coverage" content={seoData.location} />
        
        {/* SEO: Open Graph Tags */}
        <meta property="og:title" content={seoData.ogTitle} />
        <meta property="og:description" content={seoData.ogDescription} />
        <meta property="og:type" content="business.business" />
        <meta property="og:url" content={seoData.ogUrl} />
        <meta property="og:image" content={seoData.ogImage} />
        <meta property="og:site_name" content={seoData.siteName} />
        
        {/* SEO: Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.twitterTitle} />
        <meta name="twitter:description" content={seoData.twitterDescription} />
        <meta name="twitter:image" content={seoData.twitterImage} />
        
        {/* Additional SEO Meta Tags */}
        <meta name="robots" content={seoData.robots} />
        <meta name="author" content={seoData.author} />
        <meta name="viewport" content={seoData.viewport} />
        <meta httpEquiv="Content-Type" content={seoData.contentType} />
        <meta name="language" content={seoData.language} />
        <meta name="revisit-after" content={seoData.revisitAfter} />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify([localBusinessSchema, medicalOrganizationSchema])}
        </script>
      </Helmet>

      <div className="chennaiii-hcura-chennai">
        {/* Hero Section with Video Background */}
       <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
         {/* Background Video */}
         <video
           autoPlay
           muted
           loop
           playsInline
           style={{
             position: 'absolute',
             top: 0,
             left: 0,
             width: '100%',
             height: '100%',
             objectFit: 'cover',
             zIndex: -2
           }}
         >
          <source src={hcuraHeroVideo} type="video/mp4" />
         </video>
       
         {/* Video Overlay */}
         <div 
           style={{
             position: 'absolute',
             top: 0,
             left: 0,
             width: '100%',
             height: '100%',
             background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
             zIndex: -1
           }}
         ></div>
       
         <div className="tambaram-hcura-hero-content-wrapper">
           <motion.h1
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8 }}
             className="tambaram-hcura-primary-title"
           >
            H-Cura Multispecialty Clinic in Chennai
           </motion.h1>
           
           <motion.h2
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.2 }}
             className="tambaram-hcura-secondary-title"
           >
             Advanced Hair, Skin, Dental & Homeopathy Treatments
           </motion.h2>
           
           <motion.p
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.4 }}
             className="tambaram-hcura-description-text"
           >
            Welcome to Chennai's best healthcare multispecialty clinic. H-Cura offers expert treatments for hair problems, skin issues, dental care, and natural healing. We help people across Chennai with advanced hair treatments, skin care, dental services, and homeopathy. Our experienced doctors use modern technology to give you the best results. Visit our convenient locations in Tambaram, Valasaravakkam, and Gerugambakkam for quality healthcare you can trust.
           </motion.p>
           
           <motion.div
             className="tambaram-hcura-action-buttons"
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.6 }}
           >
             <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Appointment</Link>
             <a href="https://wa.me/918870001377" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
               <FaWhatsapp /> WhatsApp Consult
             </a>
           </motion.div>
       
           <motion.div
             className="tambaram-hcura-location-navigation"
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.65 }}
           >
             <div className="tambaram-hcura-location-header">
               <FaMapMarkerAlt className="tambaram-hcura-location-icon" />
               <span className="tambaram-hcura-location-title">Our Chennai Locations</span>
             </div>
             
             <div className="tambaram-hcura-location-buttons">
               <Link to="/multispecialty-clinic-in-gerugambakkam-chennai" className="tambaram-hcura-location-btn">
                 <FaDirections />
                 <span>Gerugambakkam</span>
               </Link>
               
               <Link to="/multispecialty-clinic-in-valasaravakkam-chennai/" className="tambaram-hcura-location-btn">
                 <FaDirections />
                 <span>Valasaravakkam</span>
               </Link>
               
               <Link to="/multispecialty-clinic-in-tambaram-chennai" className="tambaram-hcura-location-btn">
                 <FaDirections />
                 <span>Tambaram</span>
               </Link>
             </div>
           </motion.div>
         </div>
       </section>

        {/* This section's content is now part of the SEO meta tags and schema, not rendered directly in the UI. */}
        {/* <section className="chennaiii-seo-locations" style={{ padding: '60px 0', backgroundColor: '#f8f9fa' }}>
          <div className="chennaiii-container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
            <div className="chennaiii-seo-content">
              <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#2c3e50' }}>
                {seoLocationContent.sectionTitle}
              </h2>
              <p style={{ textAlign: 'center', marginBottom: '40px', fontSize: '16px', lineHeight: '1.6', color: '#5a6c7d' }}>
                {seoLocationContent.sectionDescription}
              </p>
              
              <div className="chennaiii-service-location-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px', marginTop: '40px' }}>
                {seoLocationContent.serviceCards.map((card, index) => (
                  <div key={index} className="chennaiii-service-location-card" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                    <h3 style={{ color: card.color, marginBottom: '15px' }}>{card.title}</h3>
                    <p style={{ color: '#5a6c7d', lineHeight: '1.6' }}>
                      {card.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section> */}

        <section id="before-after" className="chennaiii-before-after">
          <div className="chennaiii-section-header">
            <span className="chennaiii-section-subtitle">Real Patient Results</span>
            <h2>Before & After Treatment Gallery</h2>
            <div className="chennaiii-decorative-line"><span className="chennaiii-decorative-icon"><FaArrowRight /></span></div>
            <p className="chennaiii-section-description">See real results from our Chennai patients. Each picture shows complete before and after changes. Click View Details to see more pictures.</p>
          </div>

          <div className="chennaiii-before-tabs">
            {['hair', 'skin'].map((s, idx) => (
              <button key={s} className={`chennaiii-ba-tab ${activeService === idx ? 'active' : ''}`} onClick={() => { handleServiceChange(idx); setIsAutoScrollPaused(true); setTimeout(() => setIsAutoScrollPaused(false), 10000); }} aria-pressed={activeService === idx}>
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
          </div>

          <div className="chennaiii-before-carousel-wrapper">
            <div className="chennaiii-before-carousel" role="list" aria-label="Before after gallery">
              {(() => {
                const svcKey = activeService === 0 ? 'hair' : 'skin';
                const items = SAMPLE_GALLERY[svcKey] || [];

                return items.map((item, idx) => (
                  <article key={item.id} className="chennaiii-ba-clean-card" role="listitem">
                    <div className="chennaiii-ba-clean-container">
                      <div className="chennaiii-ba-clean-image-wrapper">
                        <img
                          src={item.combined}
                          alt={`${item.title} transformation results at H-Cura Chennai - Before and after comparison showing successful treatment outcomes`}
                          title={`${item.title} - Complete Before and After Results at H-Cura Chennai`}
                          className="chennaiii-ba-clean-image"
                          loading={idx < 4 ? "eager" : "lazy"}
                        />
                        <div className="chennaiii-ba-clean-title">
                          <h4>{item.title}</h4>
                        </div>
                      </div>
                      <div className="chennaiii-ba-clean-actions">
                        <button
                          className="chennaiii-ba-clean-view-btn"
                          onClick={() => openChennaiBaModal(svcKey, idx)}
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </article>
                ));
              })()}
            </div>
          </div>
        </section>

        {/* Modal viewer for detailed view with scrolling */}
        {chennaiBaModalOpen && (
          <div className="chennaiii-ba-modal" role="dialog" aria-modal="true" aria-label="Before and after detailed gallery">
            <div className="chennaiii-ba-modal-backdrop" onClick={closeChennaiBaModal} />
            <div className="chennaiii-ba-modal-panel">
              <header className="chennaiii-ba-modal-header">
                <h3>Treatment Results Gallery</h3>
                <button className="chennaiii-ba-modal-close" onClick={closeChennaiBaModal} aria-label="Close gallery">×</button>
              </header>

              <div className="chennaiii-ba-modal-body">
                <div className="chennaiii-ba-scrollable-container">
                  <div className="chennaiii-ba-scroll-track" id="scrollTrack">
                    <div className="chennaiii-ba-scrollable-grid" id="scrollableGrid">
                      {chennaiBaModalItems.map((item, index) => (
                        <div key={item.id} className="chennaiii-ba-scrollable-card" data-index={index}>
                          <div className="chennaiii-ba-scrollable-image-container">
                            <img
                              src={item.combined}
                              alt={`${item.title} detailed transformation view - Complete before and after results showing successful treatment at H-Cura Chennai`}
                              title={`${item.title} - Detailed Before After Results Gallery`}
                              className="chennaiii-ba-scrollable-image"
                              loading="lazy"
                            />
                          </div>
                          <div className="chennaiii-ba-scrollable-content">
                            <h4>{item.title}</h4>
                            <p className="chennaiii-ba-scrollable-testimonial">"{item.testimonial?.quote || ''}"</p>
                            <div className="chennaiii-ba-scrollable-author">— {item.testimonial?.author || ''}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Scroll Progress Bar */}
                  <div className="chennaiii-ba-scroll-progress">
                    <div className="chennaiii-ba-progress-bar" id="progressBar"></div>
                  </div>
                </div>

                {/* Enhanced Navigation Controls */}
                <div className="chennaiii-ba-enhanced-controls">
                  <div className="chennaiii-ba-nav-buttons">
                    <button
                      className="chennaiii-ba-nav-btn chennaiii-ba-prev-btn"
                      id="prevBtn"
                      onClick={() => scrollGallery('prev')}
                      aria-label="Previous results"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                      </svg>
                      Previous
                    </button>

                    <button
                      className="chennaiii-ba-nav-btn chennaiii-ba-next-btn"
                      id="nextBtn"
                      onClick={() => scrollGallery('next')}
                      aria-label="Next results"
                    >
                      Next
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* WHY CHOOSE - Updated with Simplified Language */}
        <section id="why-choose" className="chennaiii-why-choose-enhanced">
          <div className="chennaiii-curved-background">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
          </div>

          <div className="chennaiii-content-wrapper">
            <motion.div className="chennaiii-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
              <span className="chennaiii-section-subtitle">Best Healthcare in Chennai</span>
              <h2>Why Choose H-Cura Clinic in Chennai?</h2>
              <div className="chennaiii-decorative-line"><span className="chennaiii-decorative-icon"><FaShieldAlt /></span></div>
              <p className="chennaiii-section-description">
                Choose H-Cura because we care about your health and happiness. Our experienced doctors use the latest technology to give you safe, effective treatments. We have convenient locations across Chennai, making it easy for you to get quality healthcare. Whether you need hair treatment, skin care, dental work, or natural healing, we provide personalized care that gets results. Come to H-Cura with confidence – we'll help you look and feel your best.
              </p>
            </motion.div>

            <div className="chennaiii-awards-banner">
              <div className="chennaiii-award"><FaStar className="chennaiii-award-icon" /><span>Best Multispecialty Clinic Chennai 2024</span></div>
              <div className="chennaiii-award"><FaCertificate className="chennaiii-award-icon" /><span>ISO  Certified</span></div>
              <div className="chennaiii-award"><FaAward className="chennaiii-award-icon" /><span>Top Healthcare Provider Tamil Nadu</span></div>
            </div>

            <motion.div className="chennaiii-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
              {features.map((feature, index) => (
                <motion.div className="chennaiii-feature-card-enhanced" key={index} variants={itemVariants}>
                  <div className="chennaiii-feature-header">
                    <div className="chennaiii-icon-container">{feature.icon}<div className="chennaiii-icon-glow"></div></div>
                    <span className="chennaiii-feature-highlight">{feature.highlight}</span>
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                  <div className="chennaiii-feature-footer">
                    <div className="chennaiii-feature-dots"><span className="chennaiii-dot"></span><span className="chennaiii-dot"></span><span className="chennaiii-dot"></span></div>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            <div className="chennaiii-testimonial-strip">
              <div className="chennaiii-testimonial-background"></div>
              <div className="chennaiii-testimonial-content">
                <div className="chennaiii-quote-marks">"</div>
                <div className="chennaiii-testimonial-slider">
                  {testimonialQuotes.map((quote, index) => (
                    <div className="chennaiii-testimonial-quote" key={index}><p>{quote}</p></div>
                  ))}
                </div>
              </div>
            </div>

            <div className="chennaiii-stats-container">
              <div className="chennaiii-stat-box"><div className="chennaiii-stat-number">8+</div><div className="chennaiii-stat-label">Years of Excellence</div></div>
              <div className="chennaiii-stat-box"><div className="chennaiii-stat-number">15+</div><div className="chennaiii-stat-label">Medical Experts</div></div>
              <div className="chennaiii-stat-box"><div className="chennaiii-stat-number">10k+</div><div className="chennaiii-stat-label">Happy Patients</div></div>
              <div className="chennaiii-stat-box"><div className="chennaiii-stat-number">98%</div><div className="chennaiii-stat-label">Success Rate</div></div>
            </div>

            <div className="chennaiii-cta-container">
              <h3>Experience the H-Cura Chennai Difference</h3>
              <p>Join thousands of satisfied patients who have transformed their lives with our expert care across Chennai.</p>
              <Link to="/bookconsultation" className="chennaiii-cta-button">Book Your Consultation</Link>
            </div>
          </div>

          <div className="chennaiii-curved-background-bottom">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,181.3C96,203,192,245,288,229.3C384,213,480,139,576,128C672,117,768,171,864,197.3C960,224,1056,224,1152,213.3C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
          </div>
        </section>

        {/* SERVICES SECTION */}
        <section id="services" className="chennaiii-services-premium-section" ref={sectionRef}>
          <div
            className={`chennaiii-services-background ${isVisible ? 'visible' : ''}`}
            style={{
              backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundAttachment: 'fixed',
              opacity: isVisible ? 1 : 0
            }}
          ></div>

          <div className="chennaiii-services-container">
            <div className={`chennaiii-services-header ${isVisible ? 'visible' : ''}`}>
              <span className="chennaiii-services-subtitle">Best Healthcare Services</span>
              <h2>Our Premium Services at H-Cura Chennai</h2>
              <div className="chennaiii-services-separator"><span></span><div className="chennaiii-separator-icon"></div><span></span></div>
              <p className="chennaiii-services-description">Get Chennai's best medical treatments with care and precision. We offer complete healthcare services using modern technology and natural healing methods.</p>
            </div>

            <div
              className={`chennaiii-services-tabs ${isVisible ? 'visible' : ''}`}
              ref={servicesRef}
              onMouseEnter={() => setIsAutoScrollPaused(true)}
              onMouseLeave={() => setIsAutoScrollPaused(false)}
              onFocus={() => setIsAutoScrollPaused(true)}
              onBlur={() => setIsAutoScrollPaused(false)}
            >
              {advancedServices.map((service, index) => {
                const sIcon = serviceIconMap[service.id] || null;
                const isActive = activeService === index;
                return (
                  <button
                    key={service.id}
                    className={`chennaiii-service-tab ${isActive ? 'active' : ''}`}
                    onClick={() => {
                      setIsAutoScrollPaused(true);
                      handleServiceChange(index);
                      setTimeout(() => setIsAutoScrollPaused(false), 10000);
                    }}
                  >
                    <span
                      className={`chennaiii-tab-icon chennaiii-${service.id}-icon bright-icon`}
                      style={{
                        backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined,
                        backgroundSize: '60% auto',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: sIcon ? sIcon.bgColor : undefined,
                        border: sIcon ? `2px solid ${sIcon.borderColor}` : undefined,
                        width: '44px',
                        height: '44px',
                        borderRadius: '12px',
                        display: 'inline-block'
                      }}
                    ></span>
                    <span className="chennaiii-tab-text">{service.title.split(' ')[0]}</span>
                    {isActive && <span className="chennaiii-progress-bar"></span>}
                  </button>
                );
              })}
            </div>

            <div className="chennaiii-tab-indicators">
              {advancedServices.map((service, index) => (
                <span
                  key={`indicator-${index}`}
                  className={`chennaiii-tab-indicator ${activeService === index ? 'active' : ''}`}
                  onClick={() => {
                    setIsAutoScrollPaused(true);
                    handleServiceChange(index);
                    setTimeout(() => setIsAutoScrollPaused(false), 10000);
                  }}
                ></span>
              ))}
            </div>

            <div className={`chennaiii-service-content-wrapper ${isVisible ? 'visible' : ''}`}>
              <div className={`chennaiii-service-main-content ${isChanging ? 'changing' : ''}`}>
                <div className="chennaiii-service-info">
                  <h3>{advancedServices[activeService].title}</h3>
                  <h4>{advancedServices[activeService].subtitle}</h4>
                  <p>{advancedServices[activeService].description}</p>

                  <div className="chennaiii-service-cta">
                    <Link to="/bookconsultation" className="chennaiii-service-btn">Book Consultation</Link>
                    <Link to={serviceLearnMoreUrl(advancedServices[activeService].id)} className="chennaiii-service-link">
                      Learn More <span className="chennaiii-arrow-icon">→</span>
                    </Link>
                  </div>
                </div>

                <div className="chennaiii-service-image-container">
                  <div className="chennaiii-service-image-wrapper">
                    <img
                      src={advancedServices[activeService].image}
                      alt={`${advancedServices[activeService].title} at H-Cura Chennai - Advanced medical treatment with modern equipment and expert doctors`}
                      title={`${advancedServices[activeService].subtitle} - Premium Healthcare at H-Cura Chennai`}
                      className="chennaiii-service-main-image"
                      loading="lazy"
                    />
                    <div className="chennaiii-image-overlay"></div>
                    <div className="chennaiii-service-badge"><span>Premium Care</span></div>
                  </div>
                </div>
              </div>

              <div className="chennaiii-service-treatments">
                <h4>Special Treatment Options</h4>
                <div className="chennaiii-treatments-slider">
                  {advancedServices[activeService].treatments.map((treatment, tIndex) => {
                    const tIcon = treatmentIconMap[treatment.icon] || null;
                    return (
                      <div className="chennaiii-treatment-card" key={tIndex}>
                        <div className="chennaiii-treatment-image">
                          <img
                            src={treatment.image}
                            alt={`${treatment.name} at H-Cura Chennai - Professional medical treatment with advanced technology and expert care`}
                            title={`${treatment.name} - Advanced Treatment Option at H-Cura Chennai`}
                            loading="lazy"
                          />
                        </div>
                        <div className="chennaiii-treatment-content">
                          <div
                            className={`chennaiii-treatment-icon chennaiii-${treatment.icon} bright-treatment-icon`}
                            style={{
                              backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined,
                              backgroundSize: '60% auto',
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat',
                              backgroundColor: tIcon ? tIcon.bgColor : undefined,
                              border: tIcon ? `2px solid ${tIcon.borderColor}` : undefined,
                              width: '56px',
                              height: '56px',
                              borderRadius: '12px',
                            }}
                          ></div>
                          <h5>{treatment.name}</h5>
                          <p>{treatment.description}</p>
                          <div className="chennaiii-treatment-benefits">
                            <h6>Key Benefits:</h6>
                            <ul>
                              {treatment.benefits.map((benefit, i) => (
                                <li key={i}><span className="chennaiii-benefit-icon">✓</span>{benefit}</li>
                              ))}
                            </ul>
                          </div>

                          <div className="chennaiii-treatment-cta">
                            <Link
                              className="chennaiii-treatment-learnmore"
                              to={serviceLearnMoreUrl(advancedServices[activeService].id)}
                            >
                              Learn More
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="chennaiii-service-testimonial">
                <div className="chennaiii-testimonial-content">
                  <div className="chennaiii-quote-icon">"</div>
                  <p>{advancedServices[activeService].testimonial.quote}</p>
                  <div className="chennaiii-testimonial-author"><strong>{advancedServices[activeService].testimonial.author}</strong> | {advancedServices[activeService].testimonial.location}</div>
                </div>
                <div className="chennaiii-testimonial-decoration"></div>
              </div>

              <div className="chennaiii-service-stats">
                <div className="chennaiii-stat-item"><div className="chennaiii-stat-number">99<span>%</span></div><div className="chennaiii-stat-label">Patient Satisfaction</div></div>
                <div className="chennaiii-stat-item"><div className="chennaiii-stat-number">8000<span>+</span></div><div className="chennaiii-stat-label">Successful Treatments</div></div>
                <div className="chennaiii-stat-item"><div className="chennaiii-stat-number">18<span>+</span></div><div className="chennaiii-stat-label">Years Experience</div></div>
                <div className="chennaiii-stat-item"><div className="chennaiii-stat-number">25<span>+</span></div><div className="chennaiii-stat-label">Specialist Doctors</div></div>
              </div>

              <div className="chennaiii-service-features">
                <div className="chennaiii-feature">
                  <div
                    className="chennaiii-feature-icon chennaiii-quality-icon"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    aria-hidden
                  >
                    <Icon name="quality-icon" size={28} />
                  </div>
                  <h5>Premium Quality</h5>
                  <p>World-class treatments and cutting-edge technologies</p>
                </div>

                <div className="chennaiii-feature">
                  <div
                    className="chennaiii-feature-icon chennaiii-personalized-icon"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    aria-hidden
                  >
                    <Icon name="personalized-icon" size={28} />
                  </div>
                  <h5>Personalized Care</h5>
                  <p>Customized treatment plans for optimal results</p>
                </div>

                <div className="chennaiii-feature">
                  <div
                    className="chennaiii-feature-icon chennaiii-affordable-icon"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    aria-hidden
                  >
                    <Icon name="affordable-icon" size={28} />
                  </div>
                  <h5>Affordable Excellence</h5>
                  <p>Premium healthcare at competitive prices</p>
                </div>
              </div>

              <div className="chennaiii-service-action">
                <h4>Ready to Experience Chennai's Finest Healthcare?</h4>
                <p>Take the first step toward better health and enhanced confidence today.</p>
                <div className="chennaiii-action-buttons">
                  <Link to="/bookconsultation" className="chennaiii-primary-action-btn">Book Appointment</Link>
                  <Link to="/contact-us/" className="chennaiii-secondary-action-btn">Contact Us</Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="chennaiii-stats-banner">
          <div className="chennaiii-stat"><h3>25,000+</h3><p>Happy Patients</p></div>
          <div className="chennaiii-stat"><h3>18+</h3><p>Years of Excellence</p></div>
          <div className="chennaiii-stat"><h3>50+</h3><p>Specialist Doctors</p></div>
          <div className="chennaiii-stat"><h3>3</h3><p>Chennai Locations</p></div>
        </section>

       <section id="locations" className="chennaiii-locations">
  <div className="chennaiii-section-header">
    <h2>Our Clinic Locations Across Chennai</h2>
    <p>Find the nearest H-Cura clinic for your healthcare needs across Chennai</p>
  </div>

  <div className="chennaiii-location-tabs">
    {Object.keys(locations).map((loc) => (
      <Link
        key={loc}
        to={`/homeopathy-clinic-in-${loc}-chennai/`}
        className={`chennaiii-location-tab ${activeLocation === loc ? 'active' : ''}`}
        onClick={() => setActiveLocation(loc)}
      >
        <FaMapMarkerAlt /> {locations[loc].name}
      </Link>
    ))}
  </div>

  <div className="chennaiii-location-details">
    <div className="chennaiii-location-card">
      <div className="chennaiii-location-header">
  <h3>{locations[activeLocation].name} Branch</h3>
  <span className="chennaiii-specialty-tag">{locations[activeLocation].specialties}</span>
</div>

      <div className="chennaiii-location-grid">
        <div className="chennaiii-location-info">
          <div className="chennaiii-info-item">
            <FaMapMarkerAlt className="chennaiii-info-icon" />
            <div><h4>Address</h4><p>{locations[activeLocation].address}</p><p><small>Nearby: {locations[activeLocation].nearbyAreas}</small></p></div>
          </div>

          <div className="chennaiii-info-item">
            <FaPhone className="chennaiii-info-icon" />
            <div><h4>Contact</h4><p>{locations[activeLocation].phone}</p><button className="chennaiii-contact-button" onClick={() => (window.location.href = `tel:${locations[activeLocation].phone.replace(/\s+/g, '')}`)}>Call Now</button></div>
          </div>

          <div className="chennaiii-info-item">
            <FaClock className="chennaiii-info-icon" />
            <div><h4>Working Hours</h4><p>{locations[activeLocation].hours}</p></div>
          </div>
        </div>

        <div className="chennaiii-popular-services">
          <h4>Popular Services at {locations[activeLocation].name}</h4>
          <ul>
            {locations[activeLocation].popularServices.map((service, index) => (
              <li key={index}><FaCheckCircle className="chennaiii-check-icon" />{service}</li>
            ))}
          </ul>
          <a href={locations[activeLocation].mapUrl} target="_blank" rel="noopener noreferrer" className="chennaiii-map-link">View on Map <FaArrowRight /></a>
        </div>
      </div>
    </div>

    <div className="chennaiii-location-image">
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '12px'
        }}
      >
        <source src={locations[activeLocation].video || locations[activeLocation].image} type="video/mp4" />
      </video>
    </div>
  </div>
</section>

        <section id="testimonials" className="chennaiii-testimonials">
  <div className="chennaiii-section-header">
    <h2>What Our Chennai Patients Say</h2>
    <p>Real experiences from our valued patients across Chennai</p>
  </div>
  <div className="chennaiii-testimonials-grid">
    <motion.div 
      className="chennaiii-testimonial-card active" 
      key={activeTestimonial}
      initial={{ opacity: 0, y: 30 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5 }}
    >
      <div className="chennaiii-testimonial-rating">
        {[...Array(5)].map((_, i) => (
          <FaStar key={i} className={i < testimonials[activeTestimonial].rating ? "chennaiii-star-filled" : "chennaiii-star-empty"} />
        ))}
      </div>
      <p className="chennaiii-testimonial-text">"{testimonials[activeTestimonial].text}"</p>
      <div className="chennaiii-testimonial-author">
        <div className="chennaiii-author-info" title={`${testimonials[activeTestimonial].name} • ${testimonials[activeTestimonial].location} • ${testimonials[activeTestimonial].service}`}>
          <h4 className="chennaiii-testimonial-name">{testimonials[activeTestimonial].name}</h4>
          <p className="chennaiii-testimonial-meta">{testimonials[activeTestimonial].location} • {testimonials[activeTestimonial].service}</p>
        </div>
      </div>
    </motion.div>
  </div>
</section>

        <section
          id="appointment"
          className="chennaiii-appointment"
          style={{
            position: 'relative',
            overflow: 'hidden',
            color: '#fff',
          }}
        >
          {/* Background Video */}
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -2
            }}
          >
            <source src={hcuraHeroVideo2} type="video/mp4" />
          </video>

          {/* Video Overlay */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))',
              zIndex: -1
            }}
          ></div>

          <div className="chennaiii-appointment-content" role="region" aria-labelledby="appointment-heading">
            <motion.h2 id="appointment-heading" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>Book Your Appointment at H-Cura Chennai</motion.h2>

            <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
              Take the first step toward better health and enhanced confidence. Schedule your visit with Chennai's premier multispecialty clinic today.
            </motion.p>

            <motion.div className="chennaiii-contact-options" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
              <div className="chennaiii-contact-option"><FaPhone /> <span>+91 88700 01377 / 99646 88333 </span></div>
              <div className="chennaiii-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">www.h-cura.com</a></div>
            </motion.div>

            <motion.div className="chennaiii-appointment-buttons" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
              <Link to="/bookconsultation" className="chennaiii-primary-button">Schedule Consultation</Link>
              <a href="https://wa.me/918870001377" className="chennaiii-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Us</a>
            </motion.div>
          </div>
        </section>

      </div>
    </>
  );
};

export default HCuraChennai;
